import src from "IMAGE";
export default { src, width: 232, height: 55, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42m3DoREAIAgFUCKYTJ53X5vBBRjQoIPIsScLEB4xpPGUnim7LtKPo4ab8vECL0YODMifDBMAAAAASUVORK5CYII="};
